import * as yup from "yup";
import { convertStringInDate } from "~services/GlobalServices";
import { db } from "~db/db";

export const utils = {
  modulePath: "/funil-de-obras",
  paths: {
    dashboard: "dashboard"
  }
}

export const randomId = (count = 20) => Math.floor(Math.random() * 10**count).toString().padStart(count, '0');

const ganhaValidation = {
  inicioConsumo: yup.date().required("Data do início do consumo obrigatória"),
  fimConsumo: yup.date().required("Data do fim do consumo obrigatória"),
};

const perdidaValidation = ({ motivoPrazo, motivoPreco }) => ({
  motivoPerdaId: yup.number("Informe o motivo da perda").required("Informe o motivo da perda"),
  ...(motivoPreco && {
    precoConcorrente: yup.number(),
    precoVC: yup.number(),
  }),
  ...(motivoPrazo && {
    prazoConcorrente: yup.string(),
    prazoVC: yup.string(),
  }),
});

export const defaultValidate = ({ ganha, perdida, motivoPrazo, motivoPreco }) => {
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  return {
    dataNegociacao: yup.date().required("Data de negociação obrigatória").min(startOfToday, "A data de negociação deve ser igual ou superior ao dia atual"),
    funilObraGrupoProdutoId: yup.number("Informe o Grupo Material").required("Informe o Grupo Material"),
    funilStatusId: yup.number("Informe status").required("Informe status"),
    funilObraFonteCaptacaoId: yup.number("Informe a fonte de captação").required("Informe a fonte de captação"),
    volumeEstimado: yup.number("Volume obrigatório").required("Volume estimado obrigatório"),
    ...(ganha ? ganhaValidation : {}),
    ...(perdida ? perdidaValidation({ motivoPrazo, motivoPreco }) : {}),
  }
};

//CAMPOS
export const getFieldsByGroupType = ({header, groupKey, disabled, handleUpdateData, handleUpdateEtapa}) => {
  let fields = {};

  if(["etapa","proxima_negociacao"].includes(groupKey)){
    fields = {
      groupLabel: header.label,
      ...(groupKey == "etapa" ?
        {
          id: randomId(5),
          label: "Etapa ",
          input: { type: "text", name: "etapa", size: "10rem", class: "ml10", disabled, onBlur: (e) => handleUpdateEtapa({ev: e, header}), value: header.etapa },
        } :
        createDateInput({ header, disabled, handleUpdate: handleUpdateData, value: header.dataNegociacao })
      )
    }
  }

  return fields;
}

export const createVolumeInput = ({header, handleUpdate, value, disabled = false, labelOn = true, label = "Volume Total: "}) => {
  return {
  ...(labelOn ? {label} : {}),
  input: {
    type: "number",
    name: "volumeEstimado",
    size: "6rem",
    disabled,
    onBlur: (e) => handleUpdate({ev: e, header}),
    value
  },
}
};

export const createDateInput = ({header, handleUpdate, value, disabled = false, labelOn = true}) => {
  return {
  ...(labelOn ? {label: "Próxima Negociação"} : {}),
  input: {
    type: "date",
    name: "dataNegociacao",
    size: "10rem",
    disabled,
    onBlur: (e) => handleUpdate({ev: e, header}),
    value
  },
}
};

export function getValueForGroupKey({groupKey, isHeader, item, handleUpdateVolume, handleUpdateData, disabled}) {
  let result = [];

  if (["grupo_nome","proxima_negociacao"].includes(groupKey)) result.push({ label: "Etapa:", value: item.etapa });

  if (groupKey != "grupo_nome") result.push({ value: item.grupoNome, class: "w200" });

  if (!isHeader) {
    result.push({ label: "Volume", value: item.volumeEstimado });

    if (groupKey !== "proxima_negociacao") {
      result.push({ label: "Próxima Negociação", value: convertStringInDate(item.dataNegociacao, "pt-BR") });
    }
  } else {
    result.push(createVolumeInput({ header: item, handleUpdate: handleUpdateVolume, disabled, value: item.volumeEstimado, label: "Volume" }));

    if (groupKey !== "proxima_negociacao") {
      result.push(createDateInput({ header: item, handleUpdate: handleUpdateData, disabled, value: item.dataNegociacao }));
    }
  }

  return [...result];
}

export const applyRandomId = (array) =>
  (Array.isArray(array) ? array : []).filter(e => e).map(e => {
    e.id = randomId(5);
    return e;
  });

export const groupByKey = (array, key) => {
  const a = array?.length > 0 ? array.reduce((grupo, objeto) => {
    const value = objeto[key];
    if (!grupo[value]) {
      grupo[value] = [];
    }
    grupo[value].push(objeto);
    return grupo;
  }, {}) : {};
  return a;
};

export const matchesNotIn = (item, notIn) => {
  return Object.entries(notIn || {}).every(([key, values]) => {
    return Array.isArray(values) ? !values.includes(item[key]) : true;
  });
};